export default "__VITE_ASSET__Bmbzky4Y__"